// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"5324e568","453":"7fbbb176","796":"879e359d"}[chunkId] + ".chunk.js";
};